import { styled } from 'styled-components';

import * as api from '../../../../api';

import { Col, Row } from 'react-bootstrap';

import { constructAddress } from '../../../../utils/practice';

import { useSelector } from 'react-redux';
import * as store from '../../../../reducers/store';

import { Link, Typography } from '@vivaahealth/design-system';
import { StyledBorder, StyledHeaderSmall } from '../Common';
import { generateGoogleMapsDirectionURL } from '../../../../utils/location';

interface Props {
  practices: api.Practice.SafePractice[];
  locationsRef?: React.RefObject<HTMLDivElement>;
}

const Locations: React.FC<Props> = ({ practices, locationsRef }) => {
  const embedded = useSelector((store: store.All) => store.embedded);
  const content = (
    <>
      <StyledHeaderSmall variant="headline-small" bold>
        Office Locations
      </StyledHeaderSmall>
      {practices.map((p, i) => (
        <Row key={i} className="me-0">
          <Col className={i !== 0 ? 'pt-3' : 'pt-1'}>
            <Typography variant="paragraph-large" bold>
              {i + 1}. {p.name}
            </Typography>
            <Typography variant="paragraph-large">
              {constructAddress(p)}
            </Typography>
            <StyledLink
              small
              target="_blank"
              href={generateGoogleMapsDirectionURL({
                address: p.address,
                city: p.city,
                state: p.state,
                zip: p.zip,
              })}
            >
              Directions
            </StyledLink>
          </Col>
        </Row>
      ))}
    </>
  );
  return (
    <>
      <StyledBorder />
      {embedded ? (
        <div ref={locationsRef}>{content}</div>
      ) : (
        <div ref={locationsRef}>{content}</div>
      )}
    </>
  );
};

export default Locations;

const StyledLink = styled(Link).attrs<{ color: string }>((props) => ({
  color: props.color || 'var(--color-shade-80)',
}))`
  color: ${(props) => props.color} !important;
  text-decoration-line: underline;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
`;
